import React, { Component } from 'react';
import { Panel } from 'react-bootstrap';
import G1RedflagComponent from './G1RedflagComponent';
import I1RedflagComponent from './I1RedflagComponent';

export default class RedflagComponent extends Component {

    getComponent() {
        if (!this.props.category) return;

        switch (this.props.category.code) {
            case "I1": return <I1RedflagComponent {...this.props} />
            case "G1": return <G1RedflagComponent {...this.props} />;
            default: return "";
        }
    }

    render() {
        const hasComponent = this.getComponent();
        return (
            <React.Fragment>
                {hasComponent &&
                    <Panel className="redflag-view">
                        <span className="panel-title">Redflag</span>
                        <hr />
                        {this.getComponent()}
                    </Panel>
                }
            </React.Fragment>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/CategoryView/Redflag/RedflagComponent.js